"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateContainerHeight = void 0;
var _react = require("react");
var _searchContext = require("./search-context");
/**
 * Updates the container height based on tile grid dimensions
 * @param {React.RefObject} tileGridRef - Reference to the tile grid element
 * @returns {Function} Callback function to update container height
 */
const useUpdateContainerHeight = tileGridRef => {
  const {
    setContainerHeight
  } = (0, _searchContext.useInternalSearch)();
  return (0, _react.useCallback)(() => {
    if (tileGridRef.current) {
      const height = tileGridRef.current.offsetHeight;
      const offsetBottom = 100;
      const newHeight = height + offsetBottom;
      setContainerHeight(`${newHeight}px`);
    }
  }, [tileGridRef, setContainerHeight]);
};
exports.useUpdateContainerHeight = useUpdateContainerHeight;